import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Screen, TopBar, Loader } from "@/components/ui";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/lib/toast";
import { labApi } from "@/data/api";
import { Field, TextField, SaveBar } from "@/components/adminui";

const EMPTY = { title: "", subtitle: "", intro: "", quick_title: "", quick_subtitle: "" };

export default function AdminLabLanding() {
  const navigate = useNavigate();
  const { token } = useAuth();
  const toast = useToast();
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    labApi.adminList(token).then((r) => setForm({ ...EMPTY, ...(r.landing || {}) })).catch(() => {}).finally(() => setLoading(false));
  }, [token]);

  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  const save = async () => {
    if (!form.title.trim()) { toast.show("Title is required"); return; }
    setSaving(true);
    try { await labApi.adminSaveLanding({ title: form.title, subtitle: form.subtitle, intro: form.intro, quick_title: form.quick_title, quick_subtitle: form.quick_subtitle }, token); toast.show("Saved ✨"); navigate("/admin/lab"); }
    catch (e) { toast.show(e.message || "Couldn't save"); } finally { setSaving(false); }
  };

  if (loading) return <Screen><TopBar title="Lab landing" /><Loader /></Screen>;

  return (
    <Screen>
      <TopBar title="Lab landing page" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 20px" }}>
        <Field label="Title"><TextField value={form.title} onChange={set("title")} data-testid="landing-title" /></Field>
        <Field label="Subtitle"><TextField value={form.subtitle} onChange={set("subtitle")} /></Field>
        <Field label="Intro (paragraphs separated by blank line)"><TextField multiline rows={5} value={form.intro} onChange={set("intro")} /></Field>
        <Field label="Quick help title"><TextField value={form.quick_title} onChange={set("quick_title")} /></Field>
        <Field label="Quick help subtitle"><TextField value={form.quick_subtitle} onChange={set("quick_subtitle")} /></Field>
        <SaveBar onSave={save} saving={saving} />
      </div>
    </Screen>
  );
}
